import { DefaultTheme, ThemeProps } from 'styled-components';
import { DesignToken } from '../types';

export const getToken =
    <T extends DesignToken>(tokenName: T) =>
    (props: ThemeProps<DefaultTheme>) =>
        props.theme.tokens[tokenName];
